var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('input',{attrs:{"id":"newFileGaleria","refs":"newFileGaleria","type":"file","hidden":""},on:{"change":_vm.readURL}}),_c('div',{staticClass:"containericone",on:{"click":_vm.chooseFiles}},[_c('font-awesome-icon',{staticClass:"icone",attrs:{"icon":['fa', 'folder']}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }